// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14qvK","col":"styles_col__2bP4_","actions":"styles_actions__Lcf4D","conflict":"styles_conflict__-0EAy"};